import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CForm,
  CFormInput,
  CFormCheck,
  CInputGroup,
  CButton,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilReload } from "@coreui/icons";
import { generateRandomPassword } from "../utils";
import i18n from "../../../../i18n";

const UserModal = ({ modal, setModal, handleSave, closeModal }) => {
  const { t } = useTranslation();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setModal((prev) => ({
      ...prev,
      data: { ...prev.data, [name]: type === "checkbox" ? checked : value },
    }));
  };

  const generatePassword = () => {
    const newPassword = generateRandomPassword(12);
    setModal((prev) => ({
      ...prev,
      data: { ...prev.data, password: newPassword },
    }));
  };

  const getTitle = () => {
    if (modal.type === "edit") return t("users.edit_modal_title");
    if (modal.type === "password")
      return `${t("users.password_modal_title")} ${modal.data?.username}`;
    return "";
  };

  return (
    <CModal alignment="center" visible={modal.visible} onClose={closeModal}>
      <CModalHeader>
        <CModalTitle>{getTitle()}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          {modal.type === "edit" && (
            <>
              <CFormInput
                label={t("users.firstname")}
                name="first_name"
                value={modal.data?.first_name || ""}
                onChange={handleInputChange}
                className="mb-3"
              />
              <CFormInput
                label={t("users.lastname")}
                name="last_name"
                value={modal.data?.last_name || ""}
                onChange={handleInputChange}
                className="mb-3"
              />
              <CFormInput
                label={t("users.email")}
                type="email"
                name="email"
                value={modal.data?.email || ""}
                onChange={handleInputChange}
                className="mb-3"
              />
              <CFormCheck
                label={t("users.is_staff_label")}
                name="is_staff"
                checked={modal.data?.is_staff || false}
                onChange={handleInputChange}
                className="mb-3"
              />
              <CFormCheck
                label={i18n.t('user_modal.access_to_markup', 'Доступ к разметке ИИ')}
                name="can_do_markup"
                checked={modal.data?.can_do_markup || false}
                onChange={handleInputChange}
                className="mb-3"
              />
            </>
          )}
          {modal.type === "password" && (
            <CInputGroup className="mb-3 password-input-group">
              <CFormInput
                label={t("users.new_password")}
                type="text"
                name="password"
                value={modal.data?.password || ""}
                onChange={handleInputChange}
                minLength={8}
              />
              <CButton
                type="button"
                color="secondary"
                variant="outline"
                onClick={generatePassword}
              >
                <CIcon icon={cilReload} /> {t("users.generate")}
              </CButton>
            </CInputGroup>
          )}
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={closeModal}>
          {t("common.cancel")}
        </CButton>
        <CButton color="primary" onClick={handleSave}>
          {t("common.save")}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

UserModal.propTypes = {
  modal: PropTypes.shape({
    type: PropTypes.string,
    data: PropTypes.object,
    visible: PropTypes.bool,
  }).isRequired,
  setModal: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default UserModal;